import dayjs, { Dayjs } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { QrCodeVisitWeb } from 'graphql/generated/graphqlTypes';

dayjs.extend(isBetween);

const NEXT_DAYS_RANGE = 7;

export enum VisitStatFilter {
  TotalExpected = 'totalExpected',
  Today = 'today',
  Tomorrow = 'tomorrow',
  Next7Days = 'next7Days'
}

export interface VisitStats {
  totalExpected: number;
  today: number;
  tomorrow: number;
  next7Days: number;
}

export const computeVisitStats = (visits: QrCodeVisitWeb[], now: Dayjs): VisitStats => {
  const tomorrow = now.add(1, 'day');
  const next7Days = now.add(NEXT_DAYS_RANGE, 'day');

  return {
    totalExpected: visits.length,

    today: visits.filter((visit) => now.isSame(visit.datetime, 'day')).length,

    tomorrow: visits.filter((visit) => tomorrow.isSame(visit.datetime, 'day')).length,

    next7Days: visits.filter((visit) => dayjs(visit.datetime).isBetween(now, next7Days, null, '[]')).length
  };
};

export const filterVisitsByStat = (visits: QrCodeVisitWeb[], filter: VisitStatFilter, now: Dayjs): QrCodeVisitWeb[] => {
  switch (filter) {
    case VisitStatFilter.Today:
      return visits.filter((visit) => now.isSame(visit.datetime, 'day'));

    case VisitStatFilter.Tomorrow: {
      const tomorrow = now.add(1, 'day');

      return visits.filter((visit) => tomorrow.isSame(visit.datetime, 'day'));
    }

    case VisitStatFilter.Next7Days: {
      const next7DaysEnd = now.add(NEXT_DAYS_RANGE, 'day');

      return visits.filter((visit) => dayjs(visit.datetime).isBetween(now, next7DaysEnd, null, '[]'));
    }

    case VisitStatFilter.TotalExpected:
    default:
      return visits;
  }
};
